import SVGProps from 'src/components/icons/config/svg-props' //
// Auto-generated file created by svgr-cli source svg-template.cjs
// Run npm run generate-icons to update
// Do not edit
const SvgDollarIcon = (props: SVGProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.size || '1em'}
    height={props.size || '1em'}
    fill="none"
    viewBox="0 0 64 64"
    role="img"
    className="icon"
    {...props}
  >
    <g fill="currentColor">
      <path d="M36.192 31.307a9 9 0 0 0-2.509-1.003l-2.163-.52a3.65 3.65 0 0 1-1.824-.83 2.33 2.33 0 0 1-.448-1.623 1.9 1.9 0 0 1 .576-1.611c.72-.39 1.54-.555 2.355-.473q1.147.004 2.284.16 1.047.129 2.072.372l.576.142v-3.18l-.364-.08a24 24 0 0 0-3.115-.471V19.2h-3.175v3.033a5.47 5.47 0 0 0-3.437 1.485 5.2 5.2 0 0 0-1.192 3.64 6.8 6.8 0 0 0 .466 2.746 3.9 3.9 0 0 0 1.472 1.738c.79.468 1.651.807 2.549 1.004l2.466.63a3.02 3.02 0 0 1 1.59.804c.326.526.471 1.144.413 1.76a2.56 2.56 0 0 1-.692 2.066c-.79.471-1.71.678-2.624.59a17.4 17.4 0 0 1-2.588-.196 22 22 0 0 1-2.304-.467l-.584-.156v3.168l.343.094c1.348.355 2.729.574 4.12.653V44.8h3.176v-3.136a5.43 5.43 0 0 0 3.373-1.728 6.13 6.13 0 0 0 1.172-3.977 7.3 7.3 0 0 0-.476-2.869 3.93 3.93 0 0 0-1.508-1.783" />
      <path d="M32 6.4A25.6 25.6 0 1 0 57.6 32 25.63 25.63 0 0 0 32 6.4m0 48A22.4 22.4 0 1 1 54.4 32 22.427 22.427 0 0 1 32 54.4" />
    </g>
  </svg>
)
export default SvgDollarIcon
